//Global constat for Layout, Left/Right Drawer
export const drawerWidth = 240;
export const miniDrawerWidth = 70;